<template>
<div class="activityTempListDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="选择活动模板" :visible.sync="dialogVisible" width="650px">
        <el-tabs type="card"  v-model="activeName" @tab-click="handleChange">
            <el-tab-pane :label="obj.providername" :name="obj.providerinnerid" v-for="(obj,index) in user.providerlist" :key="index">
                <activityTempList :ref="'activityTempList'+ obj.providerinnerid" @close="close"></activityTempList>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>
</div>
</template>

<script>

import {getBrandList} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import ActivityTempList from 'views/brandBusiness/activityMgt/activity/components/activityTempList.vue'
import $ from 'jquery'
export default {
    name: 'activityTempListDialog',
    data() {
        return {
            activeName: '',
            dialogVisible: false
        }
    },
    mounted() {},
    methods: {
        handleChange() {
            this.$refs['activityTempList' + this.activeName][0].getList(this.activeName)
        },
        openDialog() {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.activeName = this.user.providerlist[0].providerinnerid
                this.$refs['activityTempList' + this.activeName][0].initList(this.activeName)
            })

        },
        close() {
            this.cancel()
        },
        cancel() {
            this.user.providerlist.forEach((obj) => {
                this.$refs['activityTempList' + obj.providerinnerid][0].initParam()
            })
            this.dialogVisible = false
        }
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        ActivityTempList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.activityTempListDialog {
}
</style>
